import type { ElementType } from 'react';

import { cn } from '@/lib/utils';

/** A module's or add-on's mark: a grey line glyph in a rounded square. */
export function PlanIcon({ Icon, size = 'md', className }: { Icon: ElementType; size?: 'sm' | 'md'; className?: string }) {
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded-lg bg-muted text-muted-foreground',
        size === 'sm' ? 'size-6 [&_svg]:size-3.5' : 'size-8 [&_svg]:size-4',
        className,
      )}
      aria-hidden
    >
      <Icon />
    </span>
  );
}
